import { ShieldCheck, Sparkles, Clock } from "lucide-react";
import { WHY_IMAGE } from "@/lib/site";

const BENEFITS = [
  {
    icon: ShieldCheck,
    title: "Zuverlässig",
    text: "Pünktlich, verlässlich und diskret – auf uns können Sie sich verlassen.",
  },
  {
    icon: Sparkles,
    title: "Gründlich",
    text: "Sorgfältige Reinigung bis ins Detail für ein makelloses Ergebnis.",
  },
  {
    icon: Clock,
    title: "Flexibel",
    text: "Termine und Leistungen individuell nach Ihren Bedürfnissen.",
  },
];

export const WhyUs = () => {
  return (
    <section
      id="ueber-uns"
      data-testid="why-us-section"
      className="py-24 md:py-32 bg-[#F8FAFC]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="relative">
            <div className="overflow-hidden rounded-3xl shadow-[0_20px_50px_rgb(10,25,47,0.12)]">
              <img
                src={WHY_IMAGE}
                alt="Gebäudereinigung in Leonberg – Reinigungskraft wischt sorgfältig eine Tischoberfläche"
                width="1264"
                height="848"
                loading="lazy"
                decoding="async"
                className="h-[420px] w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:right-6 rounded-2xl bg-[#0A192F] px-8 py-6 shadow-xl">
              <p className="font-heading text-3xl font-bold text-white">100%</p>
              <p className="text-sm text-slate-300">Fokus auf Sauberkeit</p>
            </div>
          </div>

          <div>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#0077E6] mb-4">
              Über uns
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A192F]">
              Warum NZ Clean?
            </h2>
            <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed">
              Wir legen großen Wert auf Sauberkeit, Zuverlässigkeit und
              persönliche Betreuung. Jede Reinigung wird individuell auf die
              Bedürfnisse unserer Kunden abgestimmt. Als Reinigungsfirma in
              Leonberg bieten wir zuverlässige Gebäudereinigung für Büros,
              Treppenhäuser, Wohnungen und Häuser.
            </p>

            <div className="mt-10 space-y-5">
              {BENEFITS.map((b, i) => {
                const Icon = b.icon;
                return (
                  <div
                    key={b.title}
                    data-testid={`benefit-${i}`}
                    className="flex items-start gap-4"
                  >
                    <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#E0F2FE] text-[#0077E6]">
                      <Icon className="h-6 w-6" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-[#0A192F]">
                        {b.title}
                      </h3>
                      <p className="text-base text-slate-600">{b.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
